import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";
import { Observable, from, EMPTY, of } from "rxjs";
import { switchMap, catchError } from "rxjs/operators";
import { MsalService } from "./msal.service";
// import { Minimatch } from "minimatch";
import { AuthenticationResult, InteractionType } from "@azure/msal-browser";
import { Injectable, Inject } from "@angular/core";
import { MSAL_INTERCEPTOR_CONFIG } from "./constants";
import { MsalInterceptorConfig } from "./msal.interceptor.config";
import { Router } from "@angular/router";
import { DatePipe } from "@angular/common";
const moment = require("moment-timezone");

@Injectable()
export class MsalInterceptor implements HttpInterceptor {
  constructor(
    @Inject(MSAL_INTERCEPTOR_CONFIG)
    private msalInterceptorConfig: MsalInterceptorConfig,
    private authService: MsalService,
    private router: Router,
    private datePipe: DatePipe
  ) {
  }
  // temp
  // setexpiresOn = true;
  // expiresOn: any;
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const scopes: any = this.getScopesForEndpoint(req.url);
    const account = this.authService.getAllAccounts()[0];
    console.log(account, "account");
    console.log(moment().unix(), "now");

    // let expiresOn = localStorage.getItem('expiresOn');
    // let currentDate = new Date();

    // temp
    // if (this.setexpiresOn) {
    // 	this.expiresOn = new Date(currentDate.setMinutes(currentDate.getMinutes() + 1));
    // 	this.setexpiresOn = false;
    // }
    // let expiresOnDate;
    // let offsetVal = moment(expiresOn).utcOffset();
    // let newCurr = moment(new Date().toUTCString()).utcOffset(offsetVal).toString();
    // let newCurrDate = moment(newCurr);

    // if (expiresOn != null && newCurrDate._isValid) {
    // 	console.log("Current Date: " + currentDate.toString())
    // 	expiresOnDate = moment(expiresOn);
    // 	console.log("Expires On Date: " + expiresOn.toString())
    //   console.log(expiresOnDate._d < newCurrDate._d,expiresOnDate,newCurrDate)
    // 	if (expiresOnDate._d < newCurrDate._d) {
    // 		console.log("--------------- Session Expired ---------------");
    //     debugger
    // 	if (
    // 		!(
    // 		  this.router.url.includes("/returnables/returns-pcb") ||
    // 		  this.router.url.includes("/reports/route-pcb")
    // 		)
    // 	  ) {
    //       console.log("localstorage")
    // 		localStorage.clear();
    // 		sessionStorage.clear();
    // 		this.router.navigate(["/"]);
    // 		// this.router.navigateByUrl(environment.TENANT_ID);
    // 		this.authService.logout();
    // 	  }else{
    // 		  this.authService.acquireTokenSilent({ scopes, account })
    // 		  .pipe(
    // 			  catchError(() => {
    // 				  console.log('error in acquireTokenSilent');
    // 				  if (this.msalInterceptorConfig.interactionType === InteractionType.Popup) {
    // 					  return this.authService.acquireTokenPopup({ ...this.msalInterceptorConfig.authRequest, scopes });
    // 				  }
    // 				  const redirectStartPage = window.location.href;
    // 				  this.authService.acquireTokenRedirect({ ...this.msalInterceptorConfig.authRequest, scopes, redirectStartPage });
    // 				  return EMPTY;
    // 			  }),

    // 			  switchMap((result: any)  => {
    // 				  console.log(result.idToken);
    // 				  console.log("result===", result);
    // 				  console.log("Token===", result.idTokenClaims['ToyotaGUID']);
    // 				  if (('ToyotaGUID' in result.idTokenClaims) && result.idTokenClaims['ToyotaGUID'].length) {
    // 					  localStorage.setItem('toyotaGUID', result.idTokenClaims['ToyotaGUID']);
    // 					  localStorage.setItem('token', result.idToken);
    // 					  localStorage.setItem('expiresOn', (result?.idTokenClaims?.exp));
    // 				  }
    // 				  return of(true);
    // 			  })
    // 		  );

    // 	  }
    // 	}
    // }

    const expiresOn = Number(sessionStorage.getItem("expiresOn"));
    const newCurr = moment().unix();

    console.log(
      "current date time-----> ",
      new Date(newCurr * 1000),
      newCurr,
      typeof newCurr
    );
    console.log(
      "Token expire date time-----> ",
      new Date(expiresOn * 1000),
      expiresOn,
      typeof expiresOn
    );

    if (expiresOn != null && newCurr != null) {

      if (expiresOn < newCurr) {

        console.log("--------------- Token time Expired ---------------");

        return this.authService.acquireTokenSilent({ scopes, account }).pipe(



          catchError(() => {



            if (

              this.msalInterceptorConfig.interactionType ===

              InteractionType.Popup

            ) {

              return this.authService.acquireTokenPopup({

                ...this.msalInterceptorConfig.authRequest,

                scopes,

              });

            }

            const redirectStartPage = window.location.href;

            this.authService.acquireTokenRedirect({

              ...this.msalInterceptorConfig.authRequest,

              scopes,

              redirectStartPage,

            });

            return EMPTY;

          }),



          switchMap((result: any) => {

            console.log(result.idToken);

            console.log("result===", result);

            console.log("Token===", result.idTokenClaims["ToyotaGUID"]);

            console.log("ent-r")

            if (('ToyotaGUID' in result.idTokenClaims) && result.idTokenClaims['ToyotaGUID'].length) {

              localStorage.setItem(

                "toyotaGUID",

                result.idTokenClaims["ToyotaGUID"]

              );

              localStorage.setItem("token", result.idToken);

              sessionStorage.setItem("expiresOn", result?.idTokenClaims?.exp);

              if (!scopes || scopes.length === 0) {

                const headers = req.headers.set(

                  "Authorization",

                  `${localStorage.getItem("token")}`

                );



                const requestClone = req.clone({ headers });

                return next.handle(requestClone);

                //return next.handle()

              }

              else {

                const headers = req.headers.set(

                  "Authorization",

                  `Bearer ${result.accessToken}`

                );



                const requestClone = req.clone({ headers });

                return next.handle(requestClone);

              }

            }

            else {

              this.router.navigate(['/'])

              localStorage.clear();

              sessionStorage.clear();

              setTimeout(() => {

                this.authService.logout();

              }, 1000);

              return of(result);

            }





          })

        );

        // }

      }

    }

    if (!scopes || scopes.length === 0) {
      const headers = req.headers.set(
        "Authorization",
        `${localStorage.getItem("token")}`
      );

      const requestClone = req.clone({ headers });
      return next.handle(requestClone);
      //return next.handle()
    }

    return this.authService.acquireTokenSilent({ scopes, account }).pipe(
      catchError(() => {
        if (
          this.msalInterceptorConfig.interactionType === InteractionType.Popup
        ) {
          return this.authService.acquireTokenPopup({
            ...this.msalInterceptorConfig.authRequest,
            scopes,
          });
        }
        const redirectStartPage = window.location.href;
        this.authService.acquireTokenRedirect({
          ...this.msalInterceptorConfig.authRequest,
          scopes,
          redirectStartPage,
        });
        return EMPTY;
      }),
      switchMap((result: AuthenticationResult) => {
        const headers = req.headers.set(
          "Authorization",
          `Bearer ${result.accessToken}`
        );

        const requestClone = req.clone({ headers });
        return next.handle(requestClone);
      })
    );
  }

  // private getScopesForEndpoint(endpoint: string): Array<string> | null {

  private getScopesForEndpoint(endpoint: string): any {
    const protectedResourcesArray = Array.from(
      this.msalInterceptorConfig.protectedResourceMap.keys()
    );
    const keyMatchesEndpointArray = protectedResourcesArray.filter((key) => {
      // const minimatch = new Minimatch(key);
      // return minimatch.match(endpoint) || endpoint.indexOf(key) > -1;
    });

    // process all protected resources and send the first matched resource
    if (keyMatchesEndpointArray.length > 0) {
      const keyForEndpoint = keyMatchesEndpointArray[0];
      if (keyForEndpoint) {
        return this.msalInterceptorConfig.protectedResourceMap.get(
          keyForEndpoint
        );
      }
    }

    return null;
  }
}
